import { makeStyles } from '@rbx/ui';
import { PRIMARY_RAIL_COLLAPSE_WIDTH, PRIMARY_RAIL_WIDTH } from '../../layout/constants';

const useRailStyles = makeStyles()((theme) => ({
  railContainer: {
    display: 'flex',
    position: 'relative',
    zIndex: 200,
    height: '100%',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: '0px 16px 16px 16px',
    gap: 8,
    backgroundColor: theme.palette.navigation.default,
    width: PRIMARY_RAIL_WIDTH,
    scrollbarWidth: 'none',
    transition: `width ${theme.transitions.duration.shortest}ms ease-out`,
  },

  railContainerTransition: {
    transition: `width ${theme.transitions.duration.shortest}ms ease-out`,
  },

  railContainerCompact: {
    width: PRIMARY_RAIL_COLLAPSE_WIDTH,
  },

  labelsRailContainer: {
    alignItems: 'center',
    transition: 'none',
  },

  headerContainer: {
    minHeight: 64,
    paddingTop: 8,
    display: 'flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
  },

  header: {
    justifyContent: 'flex-start',
    textWrap: 'nowrap',
    minWidth: 'unset',
    paddingLeft: 10,
    transition: `opacity ${theme.transitions.duration.shortest}ms ease-out`,
    '&:hover': {
      backgroundColor: 'unset',
    },
  },

  headerCollapseIcon: {
    height: 'fit-content',
  },

  railItem: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    textWrap: 'nowrap',
    minWidth: 'unset',
    paddingLeft: 10,
    wordBreak: 'break-all',
  },

  railItemBottom: {
    marginTop: 'auto',
  },

  activeRailItem: {
    backgroundColor: theme.palette.actionV2.secondary.fill,
  },

  railItemVertical: {
    flexDirection: 'column',
    width: '58px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'center',
    textWrap: 'wrap',
    height: 'fit-content',
    minHeight: 'unset',
  },

  railItemIconOnly: {
    maxWidth: 40,
    paddingLeft: 10,
    paddingRight: 10,
  },

  startIcon: {
    marginLeft: 0,
    marginRight: 0,
  },

  label: {
    opacity: 1,
    paddingLeft: 20,
  },

  labelTransition: {
    transition: `opacity ${theme.transitions.duration.shortest}ms ease-out, width ${theme.transitions.duration.shortest}ms ease-out`,
  },

  verticalLabel: {
    paddingLeft: 0,
  },

  headerLabel: {
    fontSize: 22,
    textTransform: 'uppercase',
  },

  hidden: {
    opacity: 0,
    width: 0,
    padding: 0,
    visibility: 'hidden',
  },
}));

export default useRailStyles;
